module.exports = __webpack_public_path__ + "static/img/IMG_20240810_164843.1be810d6.jpg";